import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('groupRequestStore', {
	state: () => {
		return {
			requests: [] // 群聊申请列表
		}
	},
	actions: {
		setRequests(requests) {
			this.requests = requests;
		},
		addRequest(request) {
			this.requests.unshift(request);
		},
		removeRequest(id) {
			for (let idx in this.requests) {
				if (this.requests[idx].id == id) {
					this.requests.splice(idx, 1);
					break;
				}
			}
		},
		clear() {
			this.requests = [];
		},
		loadRequest() {
			return http({
				url: '/group/request/list',
				method: 'GET'
			}).then((requests) => {
				this.setRequests(requests);
			});
		}
	}
});

